import {
    Button,
    Checkbox,
    ConfigProvider,
    Form,
    Input,
    Select,
    Space,
    Tag,
    message,
    Switch,
    Popover,
} from 'antd';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useModal } from '@ebay/nice-modal-react';
import { AUTO_LIGHT_TYPES, DocType, isDocTypeSupport } from '../const';
import ModelSelector from '../Step1/components/ModelSelector';
import { summaryStore } from '../store';
import ContentEnrichmentModalForStep1 from '../components/ContentEnrichmentModalForStep1';
import './styles/GraduationThesisStep1.scss';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useDevice } from '../../../hooks/useDevice';

// 毕业论文/开题报告/文献综述第一步
const GraduationThesisStep1 = observer(() => {
    const [showAdditionalNote, setShowAdditionalNote] = useState(false);
    const contentEnrichmentModal = useModal(ContentEnrichmentModalForStep1);

    const { isMobile } = useDevice();
    return (
        <div className="graduation-thesis-step1 w-full">
            <div className="flex h-max w-full flex-col items-start rounded-lg">
                <Space.Compact className={'w-full'}>
                    <Select
                        size="large"
                        className="subject-select"
                        options={[
                            {
                                label: 'AI识别学科',
                                value: 'ai-recognized',
                            },
                        ]}
                        placeholder="AI识别学科"
                        value="ai-recognized"
                        style={{
                            width: 160,
                            height: '56px',
                        }}
                    />
                    <Input
                        placeholder="请输入文章题目"
                        size="large"
                        style={{ width: '100%' }}
                        value={summaryStore.majorName}
                        onChange={(e) => summaryStore.changeMajorName(e.target.value)}
                        disabled={summaryStore.isLoadingSummary}
                    />
                </Space.Compact>
                {
                    // 毕业长文展示全部（图、表、公式、代码）
                    // 开题报告/文献综述只展示图、表

                    (summaryStore.docType === DocType.LITERATURE_REVIEW ||
                        summaryStore.docType === DocType.GRADUATION_THESIS ||
                        summaryStore.docType === DocType.TERM_PAPER ||
                        summaryStore.docType === DocType.PROPOSAL_REPORT) && (
                        <div className="flex-col md:flex-row">
                            <div
                                className={
                                    'flex w-full flex-col md:mt-6 md:flex-row md:items-center'
                                }
                            >
                                <div className="mt-6 flex flex-1 gap-3 md:mt-0">
                                    {AUTO_LIGHT_TYPES.filter(({ value }) => {
                                        // 毕业长文显示全部
                                        if (
                                            summaryStore.docType === DocType.GRADUATION_THESIS ||
                                            summaryStore.docType === DocType.TERM_PAPER
                                        ) {
                                            return true;
                                        }
                                        // 开题报告和文献综述只显示图和表
                                        if (
                                            summaryStore.docType === DocType.PROPOSAL_REPORT ||
                                            summaryStore.docType === DocType.LITERATURE_REVIEW
                                        ) {
                                            return value === 'TABLE' || value === 'DIAGRAM';
                                        }
                                        return true;
                                    }).map(
                                        ({ value, label, icon, activeIcon, activeUltraIcon }) => {
                                            const isActive =
                                                summaryStore.autoLightTypes.includes(value);

                                            return (
                                                <Tag
                                                    key={value}
                                                    onClick={() => {
                                                        if (summaryStore.isLoadingSummary) return;
                                                        const newTypes =
                                                            summaryStore.autoLightTypes.includes(
                                                                value,
                                                            )
                                                                ? summaryStore.autoLightTypes.filter(
                                                                      (type) => type !== value,
                                                                  )
                                                                : [
                                                                      ...summaryStore.autoLightTypes,
                                                                      value,
                                                                  ];
                                                        summaryStore.onAutoLightChange(newTypes);
                                                    }}
                                                    className={twMerge(
                                                        'flex cursor-pointer items-center gap-1 rounded-md bg-[#F8FBFF] px-2 py-1 md:px-5',
                                                        isActive && 'tag-primary-bg',
                                                        summaryStore.isLoadingSummary &&
                                                            'cursor-not-allowed opacity-60',
                                                    )}
                                                >
                                                    <img
                                                        src={
                                                            isActive
                                                                ? summaryStore.useUltra
                                                                    ? activeUltraIcon
                                                                    : activeIcon
                                                                : icon
                                                        }
                                                        alt={label}
                                                        className="h-4 w-4"
                                                    />
                                                    <span
                                                        className={twMerge(
                                                            'text-sm',
                                                            isActive && 'text-primary',
                                                        )}
                                                    >
                                                        {label}
                                                    </span>
                                                </Tag>
                                            );
                                        },
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>

            <div className="mt-6 md:flex">
                <Form.Item
                    layout="vertical"
                    label={<div className={'text-sm font-medium'}>关键词</div>}
                    name="keywords"
                    tooltip="关键词的质量会很大程度影响生成的效果"
                    className="flex-1 md:flex-[40%]"
                >
                    <Select
                        style={{ width: '100%' }}
                        mode="tags"
                        value={summaryStore.qy.keywords}
                        tokenSeparators={[',', '，', ' ', '、', ';', '；']}
                        placeholder="关键词请用，或、或；或空格隔开"
                        onChange={(value) => {
                            summaryStore.setKeywords(value);
                        }}
                        className="keywords-select"
                    />
                </Form.Item>
                <Form.Item
                    label={<div className={'text-sm font-medium'}>选择语气</div>}
                    layout="vertical"
                    className="flex-1 md:ml-5 md:flex-[40%]"
                >
                    <Select
                        placeholder="学术性"
                        options={[
                            { value: '学术性', label: '学术性' },
                            { value: '有说服力的', label: '有说服力的' },
                            { value: '专业的', label: '专业的' },
                            { value: '正式的', label: '正式的' },
                            { value: '书面得体的', label: '书面得体的' },
                        ]}
                    />
                </Form.Item>
            </div>
            {isDocTypeSupport.wordCountAndModel(summaryStore.docType) && <ModelSelector />}
            <div className="mt-2 flex w-full flex-col items-start">
                <div className="flex items-center gap-2">
                    <Checkbox
                        checked={showAdditionalNote}
                        onChange={(e) => setShowAdditionalNote(e.target.checked)}
                    >
                        <span className="font-semibold text-[#192038]">
                            补充说明
                            {showAdditionalNote ? '：' : ''}
                        </span>
                    </Checkbox>
                </div>

                {showAdditionalNote && (
                    <div className="w-full">
                        <Input.TextArea
                            placeholder="补充相关作者、人物关系、作品简要、实验数据、写作方向等，可更好的帮助生成论文"
                            value={summaryStore.additionalNotes}
                            onChange={(e) => summaryStore.setAdditionalNotes(e.target.value)}
                            maxLength={5000}
                            showCount
                            className="w-full rounded-lg border border-[#E5E6EB] bg-[#F8FBFF]"
                            style={{ resize: 'vertical', height: 300 }}
                        />
                    </div>
                )}
            </div>
            <div className="mt-12 flex justify-center">
                <button
                    className="unlock-button"
                    disabled={summaryStore.qy.nextLoading}
                    onClick={async () => {
                        // if (!summaryStore.isCheckConfirm) {
                        //     message.info('请先阅读并同意服务条款');
                        //     return;
                        // }
                        // 先检查是否输入了题目
                        if (!summaryStore.majorName) {
                            message.warning('请输入全文题目后一键生成');
                            return;
                        }
                        // 检查是否选择了附加服务，如果没有则显示弹窗
                        if (
                            summaryStore.autoLightTypes.length === 0 &&
                            !summaryStore.hasConfirmTable
                        ) {
                            try {
                                await contentEnrichmentModal.show();
                                summaryStore.hasConfirmTable = true;
                                // 确认后继续执行step1Submit
                                summaryStore.step1Submit();
                            } catch (error) {
                                // 用户取消或关闭弹窗，不执行任何操作
                            }
                            return;
                        }
                        summaryStore.step1Submit();
                    }}
                >
                    {summaryStore.qy.nextLoading ? '加载中...' : '免费解锁'}
                </button>
            </div>
            {isDocTypeSupport.threeOutline(summaryStore.docType) && (
                <div className="mt-4 flex items-center justify-center">
                    <Switch
                        checked={summaryStore.isUseThreeOutline}
                        onChange={(checked) => {
                            summaryStore.setIsUseThreeOutline(checked);
                        }}
                    ></Switch>
                    <div className="ml-1 flex items-center">
                        使用三级大纲
                        <Popover
                            trigger={isMobile ? 'click' : 'hover'}
                            content={
                                <div className="max-w-[300px] text-sm">
                                    <div className="mb-2 font-medium">三级大纲说明：</div>
                                    <div className="text-gray-600">
                                        • 二级大纲：极速简约，结构清晰
                                        <br />
                                        • 三级大纲：内容丰富，深度思考
                                        <br />
                                        <br />
                                        选择三级大纲可以获得更详细的长文结构规划，但生成时间会相应增加。建议重要长文使用三级大纲。
                                    </div>
                                </div>
                            }
                        >
                            <QuestionCircleOutlined className="ml-1" />
                        </Popover>
                    </div>
                </div>
            )}
        </div>
    );
});

export default GraduationThesisStep1;
